export default "https://cdn-static.gokick.com/assets/34e3985c60c1a4021cd40bb2eb2cab3e4962f61f/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";